module.exports = __webpack_public_path__ + "img/various-bac.4a9b1311.png";